import get from 'lodash.get';

const getSites = (rootState) => get(rootState, 'sites', []);

export default getSites;
